module.exports = __webpack_public_path__ + "static/media/Hausmart_logo_black.14d7d6ca.svg";